import {
  NotificationPermission,
  UserContextValue,
  Authentication,
  Impersonation,
  User,
  UserAcknowledgements,
  JobSearchHistory,
  JobSearch,
} from "./types";

const authenticationStub: Authentication = {
  currentUser: null,
  getAccessToken: async () => null,
  login: async () => {},
  logout: async () => {},
};

const impersonationStub: Impersonation = {
  impersonatedUser: null,
  canImpersonate: false,
  assumeUser(_: User) {},
  clearAssumedUser() {},
};

export const jobSearchHistoryStub: JobSearchHistory = {
  jobSearches: [],
  addJobSearch(_: JobSearch) {},
  clearJobSearches() {},
};

export const userAcknowledgementsStub: UserAcknowledgements = {
  acknowledgedEmailChangeExpired: false,
  setAcknowledgedEmailChangeExpired(_: boolean) {},
  acknowledgedNotificationBadgeState: NotificationPermission.UNDETERMINED,
  setAcknowledgedNotificationBadgeState(_: NotificationPermission) {},
};

export const initialUserContext: UserContextValue = {
  ...authenticationStub,
  ...impersonationStub,
  ...userAcknowledgementsStub,
  ...jobSearchHistoryStub,
  initialized: false,
};
